import { render, staticRenderFns } from "./usrbox.vue?vue&type=template&id=5b569eca&scoped=true"
import script from "./usrbox.vue?vue&type=script&lang=js"
export * from "./usrbox.vue?vue&type=script&lang=js"
import style0 from "./usrbox.vue?vue&type=style&index=0&id=5b569eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b569eca",
  null
  
)

export default component.exports